import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { solutionPartners } from '@/mocks/data';

export default function PartnersPreview() {
  const { t } = useTranslation();

  return (
    <section className="relative section-py bg-background-100 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-primary-50/30 blur-3xl"></div>
      <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-accent-50/20 blur-3xl"></div>

      <div className="container-page relative">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-accent-600 mb-4">
            Güçlü İş Birlikleri
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-[1.1] tracking-tight mb-5">
            {t('home.partnersTitle')}
          </h2>
          <p className="text-foreground-500 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            {t('home.partnersSubtitle')}
          </p>
        </div>

        {/* Partners marquee-style grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4 mb-12">
          {solutionPartners.map((partner) => (
            <div
              key={partner.id}
              className="relative group bg-background-50 rounded-2xl border border-foreground-100/40 p-6 flex flex-col items-center justify-center gap-3 hover:border-primary-200 hover:shadow-lg hover:shadow-primary-50/30 transition-all duration-300 cursor-pointer min-h-[110px]"
            >
              {/* Placeholder for brand logo */}
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-foreground-50 text-foreground-400 group-hover:bg-primary-50 group-hover:text-primary-500 transition-all duration-300">
                <i className="ri-building-4-line text-xl"></i>
              </div>
              <span className="text-xs font-semibold text-foreground-700 text-center leading-snug group-hover:text-foreground-900 transition-colors">
                {partner.name}
              </span>
              <span className="text-[10px] text-foreground-400 font-medium">
                {partner.country}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/cozum-ortaklarimiz"
            className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 font-semibold rounded-xl hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer group shadow-lg shadow-foreground-950/5 hover:shadow-xl hover:shadow-foreground-950/10 hover:-translate-y-0.5"
          >
            <span className="text-sm">Tüm Çözüm Ortaklarımızı Keşfedin</span>
            <i className="ri-arrow-right-line text-lg w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}